const ProductsPage = () => (
  <div />
);

export default ProductsPage;
